import React from 'react'

function HomeButton(props) {
  return (
    <div className="col justify-content-center align-self-center">
      <a href="/">
        <button className="btn btn-warning my-2 row">
          
            <span
              className="col text-light"
              style={{
                fontSize: "16px",
                fontFamily: "Arial, sans-serif",
              }}
            >
              {" "}
            {props.home}
            </span>
          
        </button>
      </a>
    </div>
  );
}

export default HomeButton
